import axios from 'axios';
import Analytics from 'shared/utility/analytics';

export const getSettings = callback => {
  Promise.all([
    axios({ method: 'post', url: '/kidwk/regulations' }),
    axios({ method: 'post', url: '/kidwk/tool-settings' }),
  ])
    .then(([{ data: regulationsMeta }, { data: { settings, meta } }]) => {
      const { uaCode } = settings;
      const data = {
        settings,
        meta: { ...meta, ...regulationsMeta },
      };
      Analytics.init('G-E724J4M3E2', uaCode);
      callback(data);
    })
    .catch(err => console.error(err));
};
